import React from 'react';

function UserGuide() {
  return <div>User guide - To come</div>;
}

export default UserGuide;
